import { useCurrentStore } from '../store';
import { useQueryParams } from '../useQueryParams';

export const useChainId = () => {
    const { chainId } = useQueryParams();
    const store = useCurrentStore();
    return chainId ? Number(chainId) : (store?.chain?.id ?? null);
};
